
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay_success",
      function () {
        return require("private-next-pages/pay_success.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay_success"])
      });
    }
  